import { graphql } from "@opensea/graphql";
import { useEffect, useRef } from "react";
import { useClient as useUrqlClient } from "urql";
import { useAccount } from "../../polychain/hooks";
import { AccountActions } from "../accountStore";
const query = graphql(`
  query TermsAcceptance($address: Address!) {
    profileByAddress(address: $address) {
      ... on Profile {
        hasAcceptedTerms
      }
    }
  }
`);
export function useLoadTermsAcceptanceForConnectedAccount({
  acceptTermsEnabled,
  trackError
}) {
  const urqlClient = useUrqlClient();
  const account = useAccount();
  const currentAddressRef = useRef(undefined);
  useEffect(function loadTermsAcceptanceForConnectedAccount() {
    currentAddressRef.current = account.address;
    const loadTermsAcceptance = async () => {
      if (!(account.address && acceptTermsEnabled)) {
        return;
      }
      try {
        const {
          data,
          error: error_0
        } = await urqlClient.query(query, {
          address: account.address
        });

        // Handle race condition where the account changed before the query completed
        if (currentAddressRef.current !== account.address) {
          return;
        }
        if (error_0) {
          trackError?.(error_0);
          AccountActions.setHasAcceptedTerms(false);
          return;
        }
        if (data?.profileByAddress.__typename !== "Profile") {
          AccountActions.setHasAcceptedTerms(false);
          return;
        }
        AccountActions.setHasAcceptedTerms(data.profileByAddress.hasAcceptedTerms ?? false);
      } catch (error) {
        trackError?.(error);
        AccountActions.setHasAcceptedTerms(false);
        return;
      }
    };
    loadTermsAcceptance();
  }, [urqlClient, trackError, acceptTermsEnabled, account.address]);
}